import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import Hero from './Components/Hero';
import Tabs from './Components/Tabs';
import Tab1 from './Components/Tab1';
 class Faq extends Component {
  render() {
    return (
      <div className="faq">
       <Hero
       title="FAQ"
       subtitle="Masih Memiliki Pertanyaan yang ingin ditanyakan?"
       />
       <Tabs></Tabs>
       <Tab1></Tab1>
      </div>
    )
  }
}

export default Faq;